import { Identifiable, Planzone, ProjectReportTemplate } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function editProjectReportTemplate(httpClient: HttpClient) {
  return (
    planzone: Identifiable<Planzone>,
    reportTemplates: Identifiable<ProjectReportTemplate>[],
  ) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/planzones/${planzone.uuid}`,
      method: HttpMethods.PATCH,
      data: {
        data: {
          projectReportTemplates: JSON.stringify(reportTemplates),
          projectReportTemplate: "",
        },
      },
    });
}

export { editProjectReportTemplate };
